import React, { Component } from 'react'
import { connect } from 'react-redux';

import PusherContext from '../../../_contexts/PusherContext'

import { service } from '../../../_services/conversation.service'

import { addMessageCollection, prependMessage, clearState, getConversation, retrieveMessages, setConversation } from '../../../_actions/conversation.actions'
import { patientActions } from '../../../_actions/patient.actions';

const withMsgStreamService = (WrappedComponent) => {
  class DataService extends Component
  {
    static contextType = PusherContext
  
    constructor(props) {
      super(props)

      this.state = {
        online: []
      }
      
      this.messagesInterval = false;
      this.conversationInterval = false;

      this.loadData = this.loadData.bind(this)
      this.handleLink = this.handleLink.bind(this)
      this.handleTyping = this.handleTyping.bind(this)
      this.handleMessage = this.handleMessage.bind(this)
      this.handleAttachment = this.handleAttachment.bind(this)
    }
  
    componentDidMount() {
      if (this.props.match && this.props.match.params.id) {
        this.props.dispatch(getConversation(this.props.match.params.id))
        this.props.dispatch(retrieveMessages(this.props.match.params.id));
      } else if (this.props.history.location.state && this.props.history.location.state.patientId) {
        this.props.dispatch(patientActions.retrieveById(this.props.history.location.state.patientId))
      } else {
        this.props.history.push('/messages');
      }
    }

    componentDidUpdate(prevProps) {
      if (!prevProps.current.conversation && this.props.current.conversation) {
        if (this.context.connection.state === 'unavailable') {
          this.initiatePolling()
        }
  
        this.initiateSocket()
      }
    }

    componentWillUnmount() {
      this.props.dispatch(clearState())

      this.unSubscribeChannels();

      this.disablePolling()
    }
      
    initiateSocket() {
      this.conversationChannel = this.context.subscribe(`presence-conversation.${this.props.current.conversation.id}`)

      this.conversationChannel
        .bind('pusher:subscription_error', data =>  {
        })
        .bind('pusher:subscription_succeeded', data =>  {
            this.setState({
              online: Object.keys(data.members)
                .filter(memberId => {
                  return parseInt(memberId) !== parseInt(this.props.currentUser.UserId)
                })
                .map(key => {
                  return {
                    ...data.members[key],
                    typing: false
                  }
                })
            })
          })
          .bind('pusher:member_added', data => {
            this.setState({
              online: [...this.state.online, {...data.info, typing: false}]
            })
          })
          .bind('pusher:member_removed', data => {
            this.setState({ 
              online: this.state.online.filter(online => {
                return online.userId !== data.id
              })
            })
          })
          .bind('client-typing', data => {
            this.setState({
              online: this.state.online.map(online => {
                return {
                  ...online,
                  typing: online.userId === data.userId ? data.typing : online.typing
                }
              })
            });
          })
          .bind('messageCreated',  message => {
            this.props.dispatch(prependMessage(message))

            service.messageRead(this.props.current.conversation.id)
              .catch(() => { })
          })
          .bind('conversationUpdatedClient',  conversation => {
            this.props.dispatch(setConversation(conversation))
          })

        this.context.connection.bind('state_change', this.connectionChange, this)
    }
  
    connectionChange(state) {
      if (state.current === 'connected') {
          this.disablePolling()
      } else if (state.current === 'unavailable' || state.current === 'failed') {
        this.initiatePolling()
      }
    }

    initiatePolling() {
      if (this.messagesInterval === false) {
        this.loadMessages(this.props.current.conversation.id)

        this.messagesInterval = setInterval(() => {
          this.loadMessages(this.props.current.conversation.id)
        }, 3000)
      }

      if (this.conversationInterval === false) {
        this.loadConversation(this.props.current.conversation.id)

        this.conversationInterval = setInterval(() => {
          this.loadConversation(this.props.current.conversation.id)
        }, 3000)

      }
    }
  
    disablePolling() {
      clearInterval(this.messagesInterval)
      clearInterval(this.conversationInterval)
    }

    loadMessages(conversationId) {
      this.props.dispatch(retrieveMessages(conversationId))
    }
  
    loadConversation(conversationId) {
      this.props.dispatch(getConversation(conversationId))
    }

    unSubscribeChannels() {
      if (this.conversationChannel) {
        this.conversationChannel.unbind();
        this.context.unsubscribe(`presence-conversation.${this.props.current.conversation.id}`)
      }

      this.context.connection.unbind('state_change', this.connectionChange, this)
    }
  
    handleAttachment(attachment) {
      const patientId =  this.props.current.conversation && this.props.current.conversation.patient ? this.props.current.conversation.patient.id : this.props.patient.id
      const conversationId = this.props.current.conversation ? this.props.current.conversation.id : null

      return service.sendOrCreateAttachment(attachment, conversationId, patientId, this.context.connection.socket_id)
        .then(this.loadData)
    }

    handleLink(link) {
      const patientId =  this.props.current.conversation && this.props.current.conversation.patient ? this.props.current.conversation.patient.id : this.props.patient.id
      const conversationId = this.props.current.conversation ? this.props.current.conversation.id : null

      return service.sendOrCreateLink(link, conversationId, patientId, this.context.connection.socket_id)
        .then(this.loadData)
    }

    handleMessage(message) {
      const patientId = this.props.current.conversation && this.props.current.conversation.patient ? this.props.current.conversation.patient.id : this.props.patient.id
      const conversationId = this.props.current.conversation ? this.props.current.conversation.id : null

      return service.sendOrCreateMessage(message, conversationId, patientId, this.context.connection.socket_id)
        .then(this.loadData)
    }

    loadData (data) {
      if (!this.props.current.conversation) {
        this.props.history.replace(`/messages/${data.id}/view`)

        this.loadConversation(data.id)
        this.loadMessages(data.id)
      } else {
        this.props.dispatch(addMessageCollection(data))
      }
    }

    handleTyping(currentUser, typing) {
      if (this.conversationChannel) {
        this.conversationChannel.trigger('client-typing', {
          typing: typing,
          userId: currentUser.UserId,
          firstName: currentUser.FirstName,
          lastName: currentUser.LastName,
          profileUrl: currentUser.profileUrlSizes ? currentUser.profileUrlSizes.sml : currentUser.ProfileUrl
        });
      }
    }

    render() {
      return <WrappedComponent
        {...this.props}
        online={ this.state.online }
        loadConversation={() => this.loadConversation(this.props.current.conversation.id) }
        isTyping={this.handleTyping}
        sendLink={this.handleLink}
        sendMessage={this.handleMessage}  
        sendAttachment={this.handleAttachment}
      />
    }
  }

  const mapStateToProps = state => {
    return {
      patient: state.patient.current,
      current: state.conversation.current,
      currentUser: state.user.currentUser,
    }
  }

  return connect(mapStateToProps)(DataService)
}

export default withMsgStreamService